import config from '@/config'
import store from '@/store'

export default {
  timeout: null,

  /**
   * Set timeout for global loading status
   */
  start () {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(() => {
      store.commit('loading', config.status.LOADING)
    }, 300)
  },

  /**
   * Clear timeout for global loading status
   * @param {number} status Status code
   */
  stop (status) {
    clearTimeout(this.timeout)
    this.timeout = null
    store.commit('loading', status)
  },

  /**
   * Finish global loading with success
   */
  success () {
    this.stop(config.status.SUCCESS)
  },

  /**
   * Finish global loading with error
   */
  error () {
    this.stop(config.status.ERROR)
  }
}
